import { EZ_ENV_SCRIPT_ID, EZ_ENV_SCRIPT_SRC, EZ_GLOBAL_CSS_ID, EZ_GLOBAL_CSS_SRC, EZ_VENDORS_SCRIPT_ID, EZ_VENDORS_SCRIPT_SRC, RC_WC_Map } from "../src/constants/wcConstants";
import { loadScript, loadStyle } from "../src/utilities/utils";
import defineCustomElement from "./defineCustomElements";
import getWCComponent from "./getWCComponent";
loadStyle(EZ_GLOBAL_CSS_ID, EZ_GLOBAL_CSS_SRC, window.document.head);
loadScript(EZ_VENDORS_SCRIPT_ID, EZ_VENDORS_SCRIPT_SRC, window.document.head);
async function loadScriptsWithPromise() {
    await loadScript(EZ_ENV_SCRIPT_ID, EZ_ENV_SCRIPT_SRC, window.document.head);
}
await loadScriptsWithPromise();
const initializeCustomElements = () => {
    for (const component in RC_WC_Map) {
        const wcName = RC_WC_Map[component].name;
        const attributes = RC_WC_Map[component].attributes;
        defineCustomElement(wcName, getWCComponent(wcName, attributes));
    }
};
initializeCustomElements();
